export default "__VITE_ASSET__DNI3vgYQ__"